export const eventNotSupported = (event, controller) => `Event '${event.eventType}' is not supported by ${controller.constructor.name}.`;
